const { CarouselElement } = window.BAO.Carousel
const { useArrows } = window.BAO.Carousel.plugins

export class ReviewCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      slides: {
        perView: 'auto',
        spacing: 10,
        origin: 'auto',
      },
      loop: false,
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 'auto',
            spacing: 15,
            origin: 'auto',
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: 'auto',
            spacing: 50,
            origin: 'auto',
          },
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [
      useArrows({
        next: this.els.next.element,
        previous: this.els.previous.element,
      }),
    ]
  }
}

customElements.define('review-carousel', ReviewCarousel)
